import { useStyletron } from '@thanx/uikit/theme'
import ProtectedPageHeader from 'components/ProtectedPageHeader'
import { useReportPermission } from 'hooks/useReportPermission'
import { buildTranslate } from 'locales'
import React from 'react'
import { Container } from 'react-bootstrap-five'
import Helmet from 'react-helmet'
import RecentSuppressions from './components/RecentSuppressions'

const t = buildTranslate('suppressions')

const SuppressionsReport: React.FC = () => {
  const [css] = useStyletron()
  const reportPermission = useReportPermission({
    rbac: 'Reports',
    legacy: 'LocationReports',
  })

  return (
    <ProtectedPageHeader
      title={t('title')}
      resource={reportPermission.resource}
      action={reportPermission.action}
      description={t('subtitle')}
    >
      <Helmet>
        <title>{t('page_title')}</title>
      </Helmet>
      <div
        className={`grey-05-bkg border-top-1 pb-xxl grey-20-border ${css({
          minHeight: `calc(100% - 50px)`,
        })}`}
      >
        <Container>
          <RecentSuppressions className="mt-xl" />
        </Container>
      </div>
    </ProtectedPageHeader>
  )
}

export default SuppressionsReport
